import styled from 'styled-components';
import { Badge } from '../../styles/common/table.styled';

const Row = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

const SmallBadge = styled(Badge)`
  height: 18px;
  padding: 0 5px;
  font-size: 11px;
`;

const RealContactName = ({ name }: { name?: string | null }) => name ? (
  <Row><span>{name}</span><SmallBadge $tone="info">실제</SmallBadge></Row>
) : null;

export default RealContactName;
